// 🔒 HARD INTERCEPT CART NAVIGATION (CAPTURE PHASE)
document.addEventListener(
  'click',
  function (e) {
    const cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"]');
    if (!cartLink) return;

    // Allow real checkout links
    if (e.target.closest('#MullyCartDrawer')) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (window.MullyCart && typeof window.MullyCart.open === 'function') {
      window.MullyCart.open();
    }
  },
  true // 👈 CAPTURE PHASE (THIS IS THE KEY)
);


(function () {
  const drawer = document.getElementById('MullyCartDrawer');
  const overlay = document.getElementById('MullyCartOverlay');
  if (!drawer || !overlay) return;

  const open = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    document.documentElement.classList.add('mully-cart-open');
  };

  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.documentElement.classList.remove('mully-cart-open');
  };

  /* ----------------------------------------
     1) INTERCEPT CART ICON / CART LINKS
  ----------------------------------------- */
  document.addEventListener('click', (e) => {
    const cartLink = e.target.closest(
      '[data-mully-cart-open], a[href="/cart"], a[href$="/cart"]'
    );
    if (!cartLink) return;

    // Allow checkout links inside the drawer
    if (e.target.closest('#MullyCartDrawer')) return;

    e.preventDefault();
    open();
  });

  /* ----------------------------------------
     2) INTERCEPT ADD-TO-CART FORMS
  ----------------------------------------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form || !form.action || !form.action.includes('/cart/add')) return;

    e.preventDefault();

    const formData = new FormData(form);

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      open();

      // Simple + safe refresh to sync drawer contents
      setTimeout(() => {
        window.location.reload();
      }, 150);
    } catch (err) {
      console.error('Add to cart failed:', err);
    }
  });

  /* ----------------------------------------
     3) UPDATE / REMOVE LINE ITEMS
  ----------------------------------------- */
  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('Cart update failed');
    return res.json();
  }

  function rerenderTotals(cart) {
    const countEl = document.getElementById('MullyCartCount');
    const totalEl = document.getElementById('MullyCartTotal');

    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) {
      totalEl.textContent = (cart.total_price / 100).toLocaleString(
        undefined,
        { style: 'currency', currency: cart.currency || 'USD' }
      );
    }
  }

  drawer.addEventListener('click', async (e) => {
    const itemEl = e.target.closest('.mully-cart__item');
    if (!itemEl) return;

    const key = itemEl.getAttribute('data-key');

    // Remove item
    if (e.target.closest('[data-mully-remove]')) {
      e.preventDefault();
      try {
        const cart = await changeLine(key, 0);
        itemEl.remove();
        rerenderTotals(cart);
        if (cart.item_count === 0) window.location.reload();
      } catch (err) {
        console.error(err);
      }
      return;
    }

    // +/- quantity
    const qtyBtn = e.target.closest('[data-mully-qty]');
    if (qtyBtn) {
      e.preventDefault();

      const delta = parseInt(qtyBtn.getAttribute('data-mully-qty'), 10);
      const input = itemEl.querySelector('[data-mully-qty-input]');
      const current = parseInt(input.value || '0', 10);
      const next = Math.max(0, current + delta);
      input.value = next;

      try {
        const cart = await changeLine(key, next);
        rerenderTotals(cart);
        if (next === 0) itemEl.remove();

        // Safe refresh to sync prices + discounts
        window.location.reload();
      } catch (err) {
        console.error(err);
      }
    }
  });

  /* ----------------------------------------
     4) EXPOSE API
  ----------------------------------------- */
  window.MullyCart = { open, close };
})();
